import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  required: {
    id: 'studio.Seanpx',
    defaultMessage: 'Required',
  },
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  default: {
    id: 'studio.pmzm1P',
    defaultMessage: 'Default value',
  },
  type: {
    id: 'studio.+U6ozc',
    defaultMessage: 'Type',
  },
  properties: {
    id: 'studio.aI80kg',
    defaultMessage: 'Properties',
  },
  options: {
    id: 'studio.NDV5Mq',
    defaultMessage: 'Options',
  },
  format: {
    id: 'studio.zQLEfz',
    defaultMessage: 'Format',
  },
  minItems: {
    id: 'studio.Ug+ut0',
    defaultMessage: 'Minimum amount of items',
  },
  maxItems: {
    id: 'studio.6k7cdT',
    defaultMessage: 'Maximum amount of items',
  },
  minLength: {
    id: 'studio.0sw2UL',
    defaultMessage: 'Minimum length',
  },
  maxLength: {
    id: 'studio.ATemBX',
    defaultMessage: 'Maximum length',
  },
  minimum: {
    id: 'studio.8bBf+m',
    defaultMessage: 'Minimum value',
  },
  maximum: {
    id: 'studio.sfFhiy',
    defaultMessage: 'Maximum value',
  },
  pattern: {
    id: 'studio.pW4lxD',
    defaultMessage: 'Pattern',
  },
  additionalProperties: {
    id: 'studio.sE+ZXx',
    defaultMessage: 'Additional properties',
  },
  additionalPropertiesAllowed: {
    id: 'studio.ZO00zQ',
    defaultMessage: 'Additional properties are allowed',
  },
});
